import {
  instance as axios,
  setJwtToken,
  setMultiPartHeader,
} from "../../config/axiosInstance";

// ---------------------Dashboard Details API---------------------------
export const fetchDashboardDetailsApi = async () => {
  const endPoint = `/admin/dashboard/details`;
  return await axios.get(endPoint, setJwtToken());
};

// Dashboard Free Trial status
export const changeFreeTrialStatus = async (data) => {
  const endPoint =
    `/admin/dashboard/free_trail` +
    "?" +
    new URLSearchParams({ ...data }).toString();
  return await axios.get(endPoint, setJwtToken());
};

// Dashboard Graph status
export const dashboardGraphApi = async (data) => {
    const endPoint =
      `/admin/dashboard/graph` +
      "?" +
      new URLSearchParams({ ...data }).toString();
    return await axios.get(endPoint, setJwtToken());
  };

// Dashboard Support Insights
export const dashboardSupportInsightsApi = async (data) => {
  const endPoint = `/admin/support/support-insights` +
    "?" +
    new URLSearchParams({ ...data }).toString();
  return await axios.get(endPoint, setJwtToken());
};

export const updateUserMasterSettingsApi = async (document, updatedData) => {
  try {
    const endPoint = `/admin/system/master/update`;
    const { data } = await axios.post(endPoint, {
      document: document,
      updatedData: updatedData
    }, setJwtToken());
    return data;
  } catch (error) {
    console.error('Error updating user master settings:', error);
    throw error;
  }
};

export const getDailyQueryPropsApi = async () => {
  const endPoint = `/admin/master/daily-query-props`;
  return await axios.get(endPoint, setJwtToken());
};

export const updateDailyQueryPropsApi = async (data) => {
  const endPoint = `/admin/master/daily-query-props`;
  return await axios.put(endPoint, data, setJwtToken());
};

export const getSystemAudioUsageApi = async () => {
  const endPoint = `/admin/master/system-audio-usage`;
  return await axios.get(endPoint, setJwtToken());
};

export const updateSystemAudioUsageApi = async (systemAudioUsage) => {
  const endPoint = `/admin/master/system-audio-usage`;
  return await axios.put(endPoint, { systemAudioUsage }, setJwtToken());
};

export const getUserMasterSettingsApi = async (document) => {
  try {
    const endPoint = `/admin/system/master/get?document=${document}`;
    const { data } = await axios.get(endPoint, setJwtToken());
    return data;
  } catch (error) {
    console.error('Error fetching user master settings:', error);
    throw error;
  }
};  

export const uploadFixedSessionImageApi = async (formData) => {
  try {
    const endPoint = `/admin/system/master/upload-fixed-session-image`;
    const { data } = await axios.post(endPoint, formData, setMultiPartHeader());
    return data;
  } catch (error) {
    console.error('Error uploading fixed session image:', error);
    throw error;
  }
};

// Generic image uploader for Settings (returns { key, url })
export const uploadSettingsImageApi = async (formData) => {
  try {
    const endPoint = `/admin/system/master/upload-fixed-session-image`;
    const { data } = await axios.post(endPoint, formData, setMultiPartHeader());
    return data;
  } catch (error) {
    console.error('Error uploading settings image:', error);
    throw error;
  }
};